/**
 * @generated SignedSource<<127ee6879b3a2a5be8e9818dc353360e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SellerReviewsPhotosCarousel_viewer$data = {
  readonly orderFeedbackMultiple: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly orderPhotos: ReadonlyArray<{
          readonly largePath: string | null;
        } | null> | null;
        readonly serviceId: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"Review_review">;
      } | null;
    } | null> | null;
    readonly totalResults: number | null;
  } | null;
  readonly " $fragmentType": "SellerReviewsPhotosCarousel_viewer";
};
export type SellerReviewsPhotosCarousel_viewer$key = {
  readonly " $data"?: SellerReviewsPhotosCarousel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SellerReviewsPhotosCarousel_viewer">;
};

import SellerReviewsPhotosCarouselRefetchQuery_graphql from './SellerReviewsPhotosCarouselRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "orderFeedbackMultiple"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 2,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "sellerId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": SellerReviewsPhotosCarouselRefetchQuery_graphql
    }
  },
  "name": "SellerReviewsPhotosCarousel_viewer",
  "selections": [
    {
      "alias": "orderFeedbackMultiple",
      "args": [
        {
          "kind": "Literal",
          "name": "excludeInAppealProcess",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "excludePrivateItemReviews",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "hasVisibleFeedbackImages",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "orderByNewest",
          "value": true
        },
        {
          "kind": "Variable",
          "name": "sellerId",
          "variableName": "sellerId"
        }
      ],
      "concreteType": "OrderFeedbackMultipleQueryConnection",
      "kind": "LinkedField",
      "name": "__SellerReviewsPhotosCarousel_orderFeedbackMultiple_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalResults",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "OrderFeedbackMultipleQueryEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrderFeedback",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "Review_review"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "OrderFeedbackPhoto",
                  "kind": "LinkedField",
                  "name": "orderPhotos",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "largePath",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "55bb8a5dd32542b2931c2a066d31982f";

export default node;
